/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-16 21:10:13
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-22 10:16:57
 */
export default {
	"menu.home": "Home",
	"menu.account": "Account",
	"menu.automatedRules": "Automated rules",
	"menu.automatedRules.manageRules": "Manage rules",
	"menu.automatedRules.rulesMarket": "Rules market",
	"menu.automatedRules.actionHistory": "Action history",
	"menu.adManagement": "Ad management",
	"menu.adManagement.create": "Create",
	"menu.adManagement.copy.adgroup": "Copy ad group",
	"menu.adManagement.copy.campaign": "Copy ad campaign",

	"menu.adManagement.runLog": "Run log",
	"menu.assetOperation": "Asset operation",
	"menu.assetOperation.materialDuplication": "Material Duplication",
	"menu.assetOperation.bindingOfSparkAds": "Binding of Spark Ads",
	"menu.logout": "Log out",
	"menu.logout.confirm.content": "Are you sure you want to log out?"
};
